import { Power4, TimelineMax, TweenMax } from 'gsap';
import $ from 'jquery';
import BaseClass from '../../libs/base/BaseClass';
import ThingsManagerClass from '../../libs/base/ThingsManagerClass';
import Util from '../../libs/util/Util';

/**
 * ボタンのタップ時のアニメーションを管理
 */
class RippleClass extends BaseClass {
  constructor(_target) {
    super();
    this.name = 'RippleClass';

    this.CL_ACTIVE = 'isActive';

    this.target = _target;

    this.onClickListener = this.onClick.bind(this);

    this.offset = null;

    this.isAnimation = false;
  }

  onCreate() {
    let html = '<span class="js-ripple_effect"><span></span></span>';

    let insertTarget = this.target;

    if ((this.target.attr('class')).indexOf('css_radio_button') !== -1) {
      insertTarget = $('> span', this.target);
    }

    this.circleWrap = ($('.js-ripple_effect', insertTarget).length < 1) ? $(html).prependTo(insertTarget) : $('.js-ripple_effect', insertTarget);
    this.circle = $('span', this.circleWrap);


    let events = '';
    if (Util.isTouch) {
      events = 'touchstart';
    } else if (Util.isPointer) {
      events = 'MSPointerDown pointerdown';
    } else {
      events = 'mousedown';
    }
    this.target.on(events, this.onClickListener);
  }

  onResize() {
    this.offset = this.target.offset();
  }

  onClick(e) {
    if (TweenMax.isTweening(this.circle)) {
      TweenMax.killTweensOf(this.circle);
      this.circle.css({ opacity: '', width: '', 'padding-bottom': '' });
    }
    this.onResize();

    const x = e.pageX - this.offset.left;
    const y = e.pageY - this.offset.top;
    this.circle.css({ top: y, left: x });

    const target = this.circle;
    const time = 0.6;
    const ease = Power4.easeOut;

    const t1 = new TimelineMax();
    t1.to(target, time * 0.25, { opacity: 1 });
    t1.to(target, time * 0.75, { opacity: 0 });
    TweenMax.to(target, time, {
      width: '200%', 'padding-bottom': '200%', ease: ease, onComplete: () => {
        this.isAnimation = false;
        target.css({ opacity: '', width: '', 'padding-bottom': '' });
      },
    });
  }
}

export default class RippleManagerClass extends ThingsManagerClass {
  constructor(_target) {
    super();
    this.name = 'RippleManagerClass';

    this._target = (_target) ? _target : 'body';
  }

  onCreate() {
    this.things = [];

    const self = this;
    $('.js-ripple', this._target).each((index, element) => {
      self.things.push(new RippleClass($(element)));
    });

    super.onCreate();
  }
}
